module.exports = __webpack_public_path__ + "img/1-20.55573ce2.png";